<template>
  <button
    class="button-base"
    @click="$emit('clicked')"
  >
    <span class="d-flex align-items-center">
      <img :src="'/img/' + image" :alt="alt" v-if="image && !iconRight" />
      <slot />
      <img :src="'/img/' + image" :alt="alt" v-if="image && iconRight" class="icon-right" />
    </span>
  </button>
</template>

<script>
import { icon } from '@fortawesome/fontawesome-svg-core';

  export default {
    props: {
      image: {
        type: String,
      },
      alt: {
        type: String,
        default: 'CyberClass'
      },
      iconRight: {
        type: Boolean,
        default: false
      },
    }
  }
</script>

<style scoped lang="scss">
  @import "~@/assets/sass/variables";

.button-base {
    display: inline-flex;
    align-items: center;
    padding: 6px 24px;
    color: $highlightPrimaryColor;
    transition: .5s all;
    border-radius: 5px;
    border: 1px solid $highlightPrimaryColor;

    span {
      color: $highlightPrimaryColor;
    }

    &:hover {
      background: rgba(252, 176, 69, 0.05);
    }

    .icon-right {
      margin-left: 8px;
    }
  }

</style>